import { Component, OnInit,Input,TemplateRef } from '@angular/core';
import { FormGroup,Validators} from '@angular/forms';
import { SetService } from 'ngx-block-core';

@Component({
  selector: 'formdiv',
  templateUrl: './formdiv.component.html',
})
export class FormdivComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() sets;
  @Input() nzBlock: TemplateRef<void>;
  @Input() nzLayout='horizontal';
  constructor(public setService:SetService) { }

  autoUpdate(){
    if(this.sets.versionCode<2){
      //vc:2
        if(typeof this.sets.styles.nzLayout['nzMarginBottom']=="undefined"){
          this.sets.styles.nzLayout['nzMarginBottom']=3;
          this.sets.styles.nzLayout['nzLineHeight']=1.4;
          this.sets.styles.nzLayout['nzFontSize']=12;
        }
      this.sets.versionCode=2;
    }
  }
  ngOnInit() {
    this.autoUpdate()
  }

}
